import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "evrideo-mam-explorer-actions-cell",
  templateUrl: "./mam-explorer-actions-cell.component.html",
  styleUrls: ["./mam-explorer-actions-cell.component.scss"],
})
export class MamExplorerActionsCellComponent
  implements ICellRendererAngularComp
{
  params: ICellRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

  onEdit(): void {
    if (this.params?.data?.id) {
      this.params.context.componentParent.onEdit(this.params.data.id);
    }
  }

  onPlay(): void {
    if (this.params?.data?.id) {
      this.params.context.componentParent.onPlay(this.params.data.id);
    }
  }

  onDownload(): void {
    if (this.params?.data?.id) {
      this.params.context.componentParent.onDownload(this.params.data.id);
    }
  }
}
